import React from "react";
import "./DashboardFooter.css";
import { useTranslation } from "../../../hooks/useTranslation";

const DashboardFooter = () => {
  const t = useTranslation();

  return (
    <footer className="dashboard-footer">
      <div className="footer-content">
        <div className="footer-logo">
          {/* <span className="logo-text">{t("footer.company.name")}</span>
          <span className="logo-tagline">{t("footer.company.tagline")}</span> */}
        </div>

        <div className="footer-links">
          <a href="/privacy-policy">{t("footer.quickLinks.privacy")}</a>
          <a href="/terms">{t("footer.terms")}</a>
          <a href="/contact">{t("footer.quickLinks.contact")}</a>
        </div>

        <div className="footer-copyright">
          <p>
            {t("footer.copyright").replace("{year}", new Date().getFullYear())}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
